module.exports = __webpack_public_path__ + "static/media/Logo-CargillPrev3.e150fd3b.png";